import { useState, useEffect } from 'react'
import { Spin } from 'antd'
import styled from 'styled-components'
import { InlineSearch } from '../search'
import { createSearchModule } from '@/modules/search'
const StyledInlineSearch = styled(InlineSearch)`
`

const StyledInlineSearchBrand = styled.span`
    display: inline-flex;
    min-width: 50px;
    margin-right: 16px;
    color: var(--primary-main-color);
    font-size: 12px;
`
const StyledInlineSearchModel = styled.span`
    font-weight: 400;
    font-size: 14px;
`
const RenderInlinModelOption = ({ item }) => {
    return <>
        <StyledInlineSearchBrand>{item.brand?.name}</StyledInlineSearchBrand>
        <StyledInlineSearchModel>{item.model_name}</StyledInlineSearchModel>
    </>
}

const ModelInlineSearch = ({ onSelect, modelsFetcher, module }) => {
    const [loading, setLoading] = useState(false)
    const [options, setOptions] = useState([])
    const [data, setData] = useState([])
    const searchModelsInline = module || createSearchModule('searchModelsInline', modelsFetcher)
    const onModelSelected = (value, option) => {
        // console.log(`inline search selected ${option}`)
        const selectedModel = data.find(item => item.id === option.id)
        if (selectedModel) {
            searchModelsInline.actions.updateSelectedItem(selectedModel)
            onSelect && onSelect(selectedModel)
        }
    }
    useEffect(() => {
        async function loadData() {
            setLoading(true)
            // const data = await modelsFetcher()
            const data = await searchModelsInline.actions.fetch_results()
            // console.log(data)
            const options = data.map(item => {
                return {
                    id: item.id,
                    value: `${item.brand.name} ${item.model_name} `,
                    label: (<RenderInlinModelOption item={item} />),
                }
            })
            setData(data)
            setOptions(options)
            setLoading(false)
        }
        loadData()

    }, [])
    if (loading) {
        return <Spin />
    }
    return <StyledInlineSearch
        options={options}
        onSelect={onModelSelected}
    />
}

export default ModelInlineSearch;
